import {
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  RolodexPermissionsValues,
} from 'types'

export const SiteMapVizEditorPermissionsList: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
]
